import React from 'react'
import Payments from './Payments'
import MobilePayments from './mobile/MobilePayments'
const PaymentPage = () => {
  return (
    <>
    <Payments />
    <MobilePayments />
    </>
  )
}

export default PaymentPage